import { render, staticRenderFns } from "./FrenchWindowSizeAndGlazing.vue?vue&type=template&id=1bdf0470&scoped=true"
import script from "./FrenchWindowSizeAndGlazing.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowSizeAndGlazing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf0470",
  null
  
)

export default component.exports